/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Agregar a la orden",
  "i18n.additionalProducts.emotionalHook": "♥️ Muy querido:",
  "i18n.additionalProducts.productDescription": "Descripción del producto",
  "i18n.additionalProducts.showMore": "Más información",
  "i18n.additionalProducts.title": "Productos adicionales",
  "i18n.button.addToCart": "Añadir a la cesta",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Aplicar",
  "i18n.button.back": "Regresar",
  "i18n.button.cancel": "Cancelar",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Cerrar",
  "i18n.button.continue": "Continuar",
  "i18n.button.ignore": "Ignorar",
  "i18n.button.ignoreAndContinue": "Continuar de todos modos",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Texto",
  "i18n.button.noChanges": "No gracias, cerrar ventana",
  "i18n.button.design": "",
  "i18n.button.photos": "Fotos",
  "i18n.button.retry": "Procesar de nuevo",
  "i18n.button.uploadPhotos": "Subir foto (s)",
  "i18n.button.withSmartSorted": "Actualizar a SMART SORTED ",
  "i18n.button.withoutSmartSorted": "No gracias, cerrar ventana",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.actionBar.duplicate": "",
  "i18n.control.actionBar.editText": "",
  "i18n.control.actionBar.leaveTextEditing": "",
  "i18n.control.actionBar.delete": "",
  "i18n.control.actionBar.rotate": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Para una mejor legibilidad, por favor acorta la longitud del texto / línea",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "La fuente seleccionada es demasiado grande para este texto.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "El tamaño máximo posible de la fuente para este texto se ha sobrepasado.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "El tamaño mínimo posible de la fuente para este texto se ha sobrepasado.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Por favor, inserta un salto de línea",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Continúa escribiendo en una segunda línea, o amplía el cuadro de texto.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Por favor, comprueba tu texto, esta fuente no es compatible con todos los caracteres.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Para una mejor legibilidad, por favor acorta la longitud del texto / línea.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Por favor amplía el cuadro de texto",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Este paso no se puede desactualizar",
  "i18n.dialog.deletePlaceholder.title": "¿Eliminar realmente el marcador de posición?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "¡La resolución de esta imagen es demasiado baja para imprimirla de manera óptima!",
  "i18n.dialog.smartSorted.message": "Con SMART SORTED puedes resolver tu imagen con 1000 piezas de forma innovadora y sin esfuerto, incluso sin muestra de la imagen",
  "i18n.dialog.smartSorted.title": "Puzzle - Sensación de éxito garantizada",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Por favor, haz clic en \"{{text}}\" para cambiar el título de la caja.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "El título de la caja no ha sido cambiado.",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuar sin título en la caja.",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Un marcador de posición no ha sido cambiado.",
    "Algunos marcadores de posición no han sido cambiados."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Marcadores de posición sin cambios.",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Interrumpiste el diseño durante mucho tiempo. No se puede continuar. Por favor, inicia el proceso nuevamente.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Una foto no pudo ser cargada. Ésta fue retirada del área de diseño y galería.",
  "i18n.error.imageLoadingError.title": "Error de descarga.",
  "i18n.error.imageProvisionError.message": "Una o más fotos no pudieron ser procesadas. El tipo de medio probablemente no sea compatible.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Archivo \"{{reference1}}\" no pudo ser procesada.",
  "i18n.error.imageSelectionError.title": "Error al subir la foto.",
  "i18n.error.imageSizeLimitExceededError.message": "La imagen que subiste es demasiado grande.\nPor favor, reduce el tamaño del archivo por debajo de 180 megapíxeles y cárgalo de nuevo.",
  "i18n.error.imageSizeLimitExceededError.title": "Error al subir la foto.",
  "i18n.error.imageUploadError.message": "Se produjo un problema de conexión a internet. Por favor inténtalo de nuevo más tarde.",
  "i18n.error.imageUploadError.title": "Error al subir la foto.",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Esta fuente no es aplicable, por favor selecciona otra fuente.",
  "i18n.error.invalidCharConfigError.title": "Fuente no aplicable",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Tu conexión a internet parece haber sido interrumpida. Puedes continuar diseñando tu producto tan pronto como tu conexión haya sido restaurada.",
  "i18n.error.templateLoadingError.message": "Plantilla \"{{ error.reference[0] }}\" no pudo ser cargada. Por favor inténtelo más tarde.",
  "i18n.error.templateLoadingError.title": "Error de descarga.",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" tiene un tipo de medio no compatible.",
  "i18n.error.unsupportedMediaTypeError.title": "Error al subir la foto.",
  "i18n.error.uploadProductError.message": "Uno o más productos no pudieron ser transferidos al servidor. Por favor, inténtalo de nuevo más tarde.",
  "i18n.error.uploadProductError.title": "Error de transferencia",
  "i18n.error.zoomModeError.message": "El texto de tu diseño anterior no pudo ser aceptado, por favor ingresa un nuevo texto.",
  "i18n.error.zoomModeError.title": "Texto no adoptado",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Precio",
  "i18n.price.reduction": "Tu ahorras ",
  "i18n.price.total": "Precio total",
  "i18n.priceDisplay.times": [
    "{{value}} pieza a {{pricePerUnit}} cada uno",
    "{{value}} piezas a {{pricePerUnit}} cada uno"
  ],
  "i18n.progress.stepAdditionalProducts": "Seleccionar accessorios",
  "i18n.progressOverlay.message.lines.one": "Gracias por tu creación esmeradamente diseñada.",
  "i18n.progressOverlay.message.lines.two": "Estamos preparando el siguiente paso para ti...",
  "i18n.template.insertText": "Ingresa un texto aquí",
  "i18n.toolbox.image.title": "Editar foto",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} fotos"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "Vista previa 3D",
  "i18n.toolbox.productChooser.title": "Cambia producto",
  "i18n.toolbox.productChooser.triggerText": "Producto",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Editar texto",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleEsES {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
